import { Api } from '@/interface/api';

import * as account from './account.srv';
import * as project from './project.srv';
import * as users from './users.srv';
import * as activity from './activity.srv';
import * as datasets from './datasets.srv';
import * as config from './config.srv';
import * as raceVideo from './race-video.srv';
import * as experts from './experts.srv';
import * as guide from './guide.srv';
import * as home from './home.srv';
import * as schedule from './schedule.srv';
import * as special from './special.srv';
import * as about from './about.srv';
import * as shippingAddress from './shipping-address.srv';
import * as contestActivity from './contest-activity.srv';
import * as weixin from './weixin.srv';
import * as raceSpecials from './race-specials.srv';
import * as competitionVisited from './competition-visited';
import * as enterprise from './enterprise';


const apis: { [key: string]: Api } = Object.assign(
    {},
    account,
    project,
    users,
    activity,
    datasets,
    raceVideo,
    experts,
    guide,
    config,
    home,
    schedule,
    special,
    about,
    shippingAddress,
    contestActivity,
    weixin,
    raceSpecials,
    competitionVisited,
    enterprise,
);
export { apis };
